export type AttributeKind = 'color' | 'wood' | 'veneer'

export type CatalogSopFile = {
  id: string
  name: string
  dataUrl: string
  uploadedAt: string
  size?: number
}

export type CatalogItem = {
  id: string
  /** Stable internal code (WAL, CRS). Never concatenated into item_code. */
  code: string
  name: string
  swatchHex?: string | null
  isActive: boolean
  /** Master note — shown on product when product uses this attribute. */
  note: string
  /** Type / Finish category: Pingment or Stain */
  type?: string | null
  /** Signing date in ISO format YYYY-MM-DD */
  signedDate?: string | null
  /** SOP workspace files (images / PDFs), mock-stored as data URLs. */
  sopFiles: CatalogSopFile[]
}

export type CatalogInput = {
  code: string
  name: string
  swatchHex?: string | null
  isActive?: boolean
  note?: string
  type?: string | null
  signedDate?: string | null
  sopFiles?: CatalogSopFile[]
}

export const COLOR_TYPE_OPTIONS = [
  { value: 'Pingment', label: 'Pingment' },
  { value: 'Stain', label: 'Stain' },
] as const

export const ATTRIBUTE_KIND_LABEL: Record<AttributeKind, string> = {
  color: 'Màu',
  wood: 'Gỗ',
  veneer: 'Veneer',
}

